export class UpdateEventQuestionRequest{
  EventID: number = -1;
  AuditResultID: number = -1;
  AuditResultDetailID: number = -1;
  QuestionID: number = -1;
  QuestionTypeID: number = -1;
  NASelected: boolean = false;
  AnswerID: number = -1;
  AnswerIDs: number[] = [];
  AnswerText: string = '';
  Comments: string = '';
  constructor(values: Object = {}){
    Object.assign(this, values);
    if (values.hasOwnProperty('AnswerIDs')){
      this.AnswerIDs = [];
      ((values as UpdateEventQuestionRequest).AnswerIDs as number[]).forEach(id => this.AnswerIDs.push(id));
    }
  }
}
